import { Flex, Typography } from "antd";
import React from "react";
import { useAppToken } from "../../../../../../theme/v6/useAppToken";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

type Props = {
  label: string;
  value: boolean;
};

const RateIncludedService = React.memo(({ label, value }: Props) => {
  const { token } = useAppToken();

  return (
    <Flex gap={4}>
      {value ? (
        <CheckOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
      ) : (
        <CloseOutlined style={{ color: token.colorTextQuaternary, fontSize: 12 }} />
      )}
      <Typography.Text ellipsis={{ tooltip: true }} style={{ fontSize: 12, color: token.colorTextSecondary }}>
        {label}
      </Typography.Text>
    </Flex>
  );
});

export default RateIncludedService;
